export default __webpack_public_path__ + "static/media/firebase.1aa395c8.svg";